/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class AwsSecurityHubFindingQueryResource extends models.QueryOperator {
    constructor() {
        super();
        this.setDiscriminator("AwsSecurityHubFindingQueryResource");
    }

    getFixupPrototypeFunction() { return AwsSecurityHubFindingQueryResource.fixupPrototype; }

    static newInstance(model: Partial<AwsSecurityHubFindingQueryResource>): AwsSecurityHubFindingQueryResource {
        let obj = Object.assign(new AwsSecurityHubFindingQueryResource(), model);
        AwsSecurityHubFindingQueryResource.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<AwsSecurityHubFindingQueryResource>): AwsSecurityHubFindingQueryResource {
        if (!model) return null;
        return AwsSecurityHubFindingQueryResource.newInstance(<AwsSecurityHubFindingQueryResource> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: AwsSecurityHubFindingQueryResource) {
        if (!obj) return;

        models.AwsSecurityHubFindingQueryResource.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: AwsSecurityHubFindingQueryResource): boolean {
        if (models.QueryOperator.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, AwsSecurityHubFindingQueryResource.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    /**
     * Resource fields for the resources
     */
    resources: Array<string>;

}
